import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface SessionExpiryDialogData {
  expiryTimeMs: number;
}

@Component({
  selector: 'app-session-expiry-dialog',
  templateUrl: './session-expiry-dialog.component.html',
  styleUrls: ['./session-expiry-dialog.component.scss']
})
export class SessionExpiryDialogComponent implements OnInit, OnDestroy {
  remainingMinutes = 0;
  private countdownInterval: ReturnType<typeof setInterval> | null = null;

  constructor(
    public dialogRef: MatDialogRef<SessionExpiryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SessionExpiryDialogData
  ) { }

  ngOnInit(): void {
    this.updateRemainingTime();
    this.countdownInterval = setInterval(() => this.updateRemainingTime(), 30000);
  }

  ngOnDestroy(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  onClose(): void {
    this.dialogRef.close('');
  }

  private updateRemainingTime(): void {
    const msRemaining = this.data.expiryTimeMs - Date.now();
    this.remainingMinutes = Math.max(1, Math.ceil(msRemaining / 60000));
  }

  onSignInNow(): void {
    this.dialogRef.close('login');
  }

  continueSession(): void {
    this.dialogRef.close('refresh');
  }
}
